/**
 * Universal Animations
 ***/
 import gsap from "gsap";
 import { Elastic, TweenLite } from "gsap/all";
 import ScrollMagic from "scrollmagic";
 import { SplitText } from "../_vendors/gsap/SplitText"
 import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

 ScrollMagicPluginGsap(ScrollMagic, TweenLite);

 var VodaAnimations = (function($) {

	const controller = new ScrollMagic.Controller();
	const EO = Elastic.easeOut.config;
	const desktopOnly = [];
	let isMobile = false;


    const onInit = function() {
		isMobile = ($('.mobile-detect').css('display') == 'block');

		if(!isMobile){
			buildRevealAnimations();
		}


		jQuery('body').css('opacity', 1);

    	$(window).resize(handleWindowResize).resize();
    }

    const onUpdate = function() {
    	handleWindowResize();
    }

	function handleWindowResize() {
    	isMobile = ($('.mobile-detect').css('display') == 'block');
		if(isMobile){

		}
	}


    function addToController( sceneObj ) {
    	if( !sceneObj.reverse ) sceneObj.reverse = true;

    	//console.log( 'adding new scene' );
    	if( sceneObj.inited ) return sceneObj.scene;
    	const scene = new ScrollMagic.Scene( sceneObj.trigger );
    	if( sceneObj.pin ) scene.setPin( sceneObj.pin );
    	if( sceneObj.gsap ) scene.setTween( sceneObj.gsap );
    	if( sceneObj.funct ) {
    		sceneObj.gsap = sceneObj.funct();
    		scene.setTween( sceneObj.gsap );
    	}
    	//scene.addIndicators({name: sceneObj.name })
    	scene.reverse(sceneObj.reverse);
    	scene.addTo( controller );

    	sceneObj.inited = true;

    	if( sceneObj.desktopOnly ) {
    		desktopOnly.push( sceneObj );
    	}

    	return scene;
    }



	function buildRevealAnimations() {
		//.wp-block-column h1, .wp-block-column h2, .wp-block-column h3, .wp-block-column h4, .wp-block-column h5, .wp-block-column img,
		$('.wp-block-column, .quote-block .quote, .pricing-section h1, .pricing-section p').each((i,el)=> {
			let triggerEle = $(el);
			let container = $(el).closest(".wp-block-columns, .quote-block, .pricing-section");
			if(!container.hasClass("step-columns") && !container.hasClass("no-animation")){
				// const text01 = new SplitText( el , {type:'lines' , linesClass:'line' } );
				// $(el).find('.line').wrapInner('<div class="wrap"></div>');
				// $(el).find('.wrap')

				let ani = null;
				if(triggerEle.hasClass("animate-from-right")){
					ani = gsap.from($(el), 1.5, {stagger:0.1, xPercent:140, ease:EO(0.6,1)} );
				}else if(triggerEle.hasClass("animate-from-left")){
					ani = gsap.from($(el), 1.5, {stagger:0.1, xPercent:-140, ease:EO(0.6,1)} );
				}else if(!triggerEle.hasClass("no-animation")){
					ani = gsap.from($(el), 1.5, {stagger:0.1, opacity: 0, yPercent:140, ease:EO(0.6,1)} );
				}

				const reveal = new ScrollMagic.Scene({
					triggerElement: container[0],
					reverse:false,
					triggerHook: "0.8",
				})
				.setTween(ani)
				.addTo(controller);
			}
		});

	}
	return {
		init: onInit,
		add : addToController,
		update : onUpdate
	};

})(jQuery);

export default VodaAnimations;



// WEBPACK FOOTER //
// ./assets/scripts/js/_components/animations.js